<div class="flow-summary-sidebar" [ngClass]="{'visible': isVisible}" [style.width.px]="sidebarWidth">
  <div class="resize-handle"
    (mousedown)="startResize($event)"
    (touchstart)="startResize($event)">
  </div>

  <div class="flow-summary-header">
    <div class="flow-summary-left">
      <img src='../../../assets/svg/flow-ai-icon.svg' />
      <p class="flow-summary-title">Flow Summary</p>
    </div>
    <button class="flow-summary-close" (click)="closeSidebar()">
      <img src="../../../assets/svg/close.svg" alt="Close" />
    </button>
  </div>

  <div class="flow-summary-content">
    <div class="flow-details">
      <div class="flow-detail-item">
        <span class="flow-detail-label">Flow name:</span>
        <span class="flow-detail-value">{{ flowData.name }}</span>
      </div>

      <div class="flow-detail-item">
        <span class="flow-detail-label">Last Edited:</span>
        <span class="flow-detail-value">{{ flowData.lastEdited }}</span>
      </div>

      <div class="flow-detail-item">
        <span class="flow-detail-label">Author:</span>
        <span class="flow-detail-value">{{ flowData.author }}</span>
      </div>

      <!--      <div class="flow-detail-item">-->
      <!--        <span class="flow-detail-label">Total Nodes:</span>-->
      <!--        <span class="flow-detail-value">{{ flowData.totalNodes }}</span>-->
    <!--      </div>-->
  </div>

  <div class="ai-summary-section-border" [ngClass]="{'regenerating': isRegenerating}">
    <div class="ai-summary-section">
      <div class="ai-summary-header">
        <p class="ai-summary-title">Clickatell AI Flow Summary</p>
        <span class="beta-badge">Beta</span>
      </div>

      <div class="ai-summary-content">
        <p [contentEditable]="aiSummary.isEditable"
          [class.editable]="aiSummary.isEditable"
          [class.typewriting]="isTypewriting"
          (blur)="onSummaryEdit($event)">
          @if (!isTypewriting) {
            <span>{{ aiSummary.description }}</span>
          }
          @if (isTypewriting) {
            <span>{{ displayedText }}<span class="typewriter-cursor">|</span></span>
          }
        </p>
      </div>

      <!-- Action Buttons -->
      <div class="summary-actions">
        <button class="action-btn"
          (click)="modifySummary()">
          <img src="../../../assets/svg/edit-grey.svg" alt="Edit" />
          {{ aiSummary.isEditable ? 'Save' : 'Modify' }}
        </button>

        <!--          <button class="action-btn lock-btn"-->
        <!--                  [ngClass]="{'locked': aiSummary.isLocked}"-->
        <!--                  (click)="lockSummary()">-->
        <!--            <img src="../../../assets/svg/lock-grey.svg" alt="Lock" />-->
        <!--            {{ aiSummary.isLocked ? 'Unlock Summary' : 'Lock Summary' }}-->
      <!--          </button>-->

      <button class="action-btn" (click)="regenerateSummary()">
        <img src="../../../assets/svg/refresh-grey.svg" alt="Regenerate" />
        Regenerate
      </button>
    </div>
  </div>
</div>
</div>
</div>

<div class="flow-summary-backdrop"
  [ngClass]="{'visible': isVisible}"
  (click)="closeSidebar()">
</div>

<ng-template #regenerateConfirmDialog>
  <div class="flow_save_new">
    <div class="flow_save_new_title">Regenerate flow summary?</div>
    <div class="flow_save_new_buttonsContainer">
      <button class="toolbar_saveBtn btnPrimary flow_save_new_button" (click)="cancelRegenerate()">
        Cancel
      </button>
      <button
        class="toolbar_saveBtn btnPrimary flow_save_new_button"
        (click)="confirmRegenerate()"
        >
        Regenerate
      </button>
    </div>
  </div>
</ng-template>
